/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Shortcut_Keys_Ad_Trim_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Trim to audio duration failed with message: {error}" |
*
* @param {Shortcut_Keys_Ad_Trim_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_ad_trim_failed_toast = /** @type {((inputs: Shortcut_Keys_Ad_Trim_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Ad_Trim_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'ajustement a la duree audio : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Das Kürzen auf die Audiodauer ist fehlgeschlagen. Fehlermeldung: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il taglio alla durata audio non è riuscito con il messaggio: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось обрезать аудиодорожку до нужной длительности с сообщением: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al ajustar la duración del audio con el mensaje: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`音频时长裁剪失败，错误信息：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`オーディオの長さに合わせてトリミングできませんでした。メッセージ: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ऑडियो अवधि के अनुसार ट्रिम करने में विफलता मिली, संदेश: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A tentativa de ajustar a duração do áudio falhou com a mensagem: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Trim to audio duration failed with message: ${i?.error}`)
});